var map = {
	"./1-circle.png": "7334",
	"./FAQ.png": "45f2",
	"./add.png": "2862",
	"./arrow-gray.png": "4fdd",
	"./attach.png": "3327",
	"./blog.png": "fdfa",
	"./camera.png": "a23b",
	"./close.png": "9c84",
	"./delete.png": "49e6",
	"./document-blue.png": "6e36",
	"./document.png": "a8e0",
	"./download.png": "a83f",
	"./edit-blue.png": "8122",
	"./edit-grey.png": "7328",
	"./error.png": "cd92",
	"./excel.png": "7fba",
	"./eye.png": "a301",
	"./flag-geo.png": "89de",
	"./flag-usa.png": "3c70",
	"./group.png": "69e5",
	"./lecturer.png": "27ff",
	"./list.png": "9df3",
	"./logout.png": "41ff",
	"./massages-blue.png": "d450",
	"./menu.png": "56b4",
	"./messages.png": "585b",
	"./notepad-pen.png": "80f2",
	"./old-icons/excel.png": "8f7a",
	"./old-icons/inst.png": "e886",
	"./old-icons/question.png": "fbbd",
	"./old-icons/send.png": "9e7c",
	"./program_dates.png": "706a",
	"./search-blue.svg": "6132",
	"./search-dark.png": "e32b",
	"./search.png": "13b1",
	"./search.svg": "f919",
	"./send.png": "0dad",
	"./settings.png": "6a88",
	"./sort.png": "4ae9",
	"./student.png": "c8a9",
	"./success.png": "434e",
	"./user.png": "0262",
	"./vc.png": "0555",
	"./video.png": "926b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";